import { render } from "./VetClaimComponent.vue?vue&type=template&id=30f9f2e4&scoped=true"
import script from "./VetClaimComponent.vue?vue&type=script&lang=js"
export * from "./VetClaimComponent.vue?vue&type=script&lang=js"

import "./VetClaimComponent.vue?vue&type=style&index=0&id=30f9f2e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f9f2e4"]])

export default __exports__